export default __webpack_public_path__ + "static/media/google-trust-services.f3c80b34.webp";